import { render, staticRenderFns } from "./choiceGood.vue?vue&type=template&id=c04a36fc&scoped=true&"
import script from "./choiceGood.vue?vue&type=script&lang=js&"
export * from "./choiceGood.vue?vue&type=script&lang=js&"
import style0 from "./choiceGood.vue?vue&type=style&index=0&id=c04a36fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04a36fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c04a36fc')) {
      api.createRecord('c04a36fc', component.options)
    } else {
      api.reload('c04a36fc', component.options)
    }
    module.hot.accept("./choiceGood.vue?vue&type=template&id=c04a36fc&scoped=true&", function () {
      api.rerender('c04a36fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/choiceGood.vue"
export default component.exports